module.exports = __webpack_public_path__ + "files/dd3fde15f5007a0470efe3e4a5c6494f.svg";